import React, { useState } from 'react';
import { Button, Tabs, TabPanel } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import styles from './TabsSection.module.less';
import Overlay from '../../../components/Overlay';
import { trackTabClick, trackTabShown } from '../../../lib/fpti';

const TabsSection = ({ ecmContent }) => {
  const {
    style = [
      {
        id: 'empty',
        label: 'No Data',
        panelId: 'empty'
      }
    ],
    cards = [
      {
        key: 'empty',
        text: 'No data found.',
        badge: '',
        url: '',
        description: ''
      }
    ]
  } = ecmContent || {};
  const [selectedTabIdx, setSelectedTabIdx] = useState(0);
  const clickTabHandler = (_evt, index) => {
    const { id } = style[index];
    trackTabClick(id);
    trackTabShown(id);
    setSelectedTabIdx(index);
  };

  return (
    <div className={`${styles.xo_container}`}>
      <Tabs
        name="checkoutOptions"
        selectedTabIdx={selectedTabIdx}
        className={`${styles.checkoutOptions}`}
        tabs={style}
        onClick={clickTabHandler}
      >
        {cards.map(({ key, text, icon, badge, url, description }) => {
          const id = key.toLowerCase().replace(' ', '-');
          return (
            <TabPanel id={id} key={id}>
              <div className={`${styles.overview_container}`}>
                <div className={styles.description_container}>
                  <div dangerouslySetInnerHTML={{ __html: text }} />
                  <Button as="a" secondary href={url} target="_blank">
                    {badge}
                  </Button>
                </div>
                {icon && (
                  <Overlay
                    src={icon}
                    fileName={`${id}.png`}
                    caption={description}
                    className={`${styles.overlay}`}
                  />
                )}
              </div>
            </TabPanel>
          );
        })}
      </Tabs>
    </div>
  );
};

TabsSection.propTypes = { ecmContent: PropTypes.object };

TabsSection.defaultProps = { ecmContent: null };

export default TabsSection;
